<template>
  <div class="avecor-table fill-height" >

    <v-tabs
      fixed-tabs
      dark
      dense
      height="35"
      v-model="selectedTab"
      class="promotion-tabs"
      background-color="#F26539"
      style="position:fixed;top:35px;z-index:20" 
    >
      <v-tabs-slider color="#FFF" ></v-tabs-slider>
      <v-tab href="#wholesaleCompanies">Tukkurit</v-tab>
      <v-tab href="#printShops">Merkkaamot</v-tab>
      <v-tab href="#others">Muut</v-tab>
    </v-tabs>
    <v-tabs-items v-model="selectedTab" class="fill-height">
      <v-tab-item value="wholesaleCompanies" class="fill-height">
          <WholesaleCompaniesTable></WholesaleCompaniesTable>
      </v-tab-item>
      <v-tab-item value="printShops" class="fill-height">
          <PrintShopsTable></PrintShopsTable>
      </v-tab-item>
      <v-tab-item value="others" class="fill-height">
          <OtherPartnersTable></OtherPartnersTable>
      </v-tab-item>
    </v-tabs-items>
    
    
    
  </div>
</template>


<script>
import { mapFields } from 'vuex-map-fields'
import WholesaleCompaniesTable from './../../components/blocks/WholesaleCompaniesTable'
import PrintShopsTable from './../../components/blocks/PrintShopsTable'
import OtherPartnersTable from './../../components/blocks/OtherPartnersTable'



export default {
    components: {
      WholesaleCompaniesTable,
      PrintShopsTable,
      OtherPartnersTable
    },
    data () {
      return {
        selectedTab:"wholesaleCompanies",
        autogrow:true,
        clipped: true,
        email: '',
        password: '',
        passwordConfirm: '',
        isTopBarFlat:true,
        clipped: true,
        clippedToolbar:true,
        alert: false,
        right: true,
        hideSlider:true,
        miniVariant: true,
        
      }
    },
    mounted() {
    },
    computed: {
      formTitle () {
      },
      ...mapFields([
        'settings.isAuthenticated',
        'settings.isSales',
        'settings.isOffice',
        'selectedView.officeView',
        'selectedView.salesView',
        'selectedView.clientView',
        'settings',
        'user',
        
      ]),
    },
    created () {},
    methods: {
      
      example(message) {
        
      }
    }
  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/views/Partners.vue